import api from './api.js';

const BASE = '/api/feedback';

export const createTicket = (formData) =>
  api.post(BASE, formData).then(r => r.data);

export const listTickets = (params = {}) =>
  api.get(BASE, { params }).then(r => Array.isArray(r.data) ? r.data : []);

export const getTicket = (id) =>
  api.get(`${BASE}/${id}`).then(r => r.data);

export const updateTicket = (id, body) =>
  api.patch(`${BASE}/${id}`, body).then(r => r.data);

export const approveTicketForBot = (id) =>
  api.post(`${BASE}/${id}/approve-for-bot`).then(r => r.data);

// Dismiss a vendor-portal ticket without ever approving it for Bosun -- reuses the existing
// close flow (PATCH .../:id, status='closed') rather than a new column/endpoint. ApprovedForBotAt
// is never touched, so the poller's own guard keeps excluding it (Status='open' alone already
// would too -- this is belt and suspenders, same as the backend's own guard comment).
export const dismissVendorTicket = (id) =>
  updateTicket(id, { status: 'closed', resolutionNote: 'Dismissed — not approved for Bosun.' });

export const addComment = (ticketId, body) =>
  api.post(`${BASE}/${ticketId}/comments`, { body }).then(r => r.data);

export const editComment = (ticketId, commentId, body) =>
  api.patch(`${BASE}/${ticketId}/comments/${commentId}`, { body }).then(r => r.data);

export const getCommentHistory = (ticketId, commentId) =>
  api.get(`${BASE}/${ticketId}/comments/${commentId}/history`).then(r => Array.isArray(r.data) ? r.data : []);
